import cx from 'classnames'

import Styles from '../StrategiesSelection.module.scss'

import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Strategy as StrategyType, description, whyWeRecommendIt } from '../utils'
import { ContentStrategyType } from 'types'
import { ContentStrategyTypeEmoji } from 'components/ContentStrategyTypeEmoji/ContentStrategyTypeEmoji'
import { ImgMap } from 'components/ContentStrategyTypeImg/ContentStrategyTypeImg'
import { CreditUsageButton } from 'blaze-ui/CreditUsageButton/CreditUsageButton'

export const StrategyHeader = ({
  strategy,
  number,
  onLaunch,
  startDate,
  isStarted = false,
  creditsNeeded,
}: {
  strategy: StrategyType
  number?: number
  onLaunch?: () => void
  startDate?: string
  isStarted?: boolean
  creditsNeeded?: number
}) => {
  return (
    <div className={cx(Styles.strategyHeader, Styles[strategy.id])}>
      <div className={cx(Styles.headingAndDescription, { [Styles.withNumber]: number !== undefined })}>
        {number !== undefined && (
          <div className={Styles.left}>
            <div className={Styles.numberContainer}>
              <div
                className={cx(Styles.number, {
                  [Styles.nextUp]: number === 2,
                  [Styles.other]: number !== 2,
                })}
              >
                {number}
              </div>
            </div>
          </div>
        )}
        <div
          className={cx(Styles.right, {
            [Styles.withStartDate]: startDate !== undefined,
            [Styles.withLaunch]: onLaunch !== undefined,
          })}
        >
          <Heading level={3} color="var(--light-100)">
            <ContentStrategyTypeEmoji contentStrategyType={strategy.id} /> {strategy.name}
          </Heading>
          <div className={Styles.description}>
            <Text color="var(--light-90)">{description[strategy.id]}</Text>
          </div>
          {startDate && isStarted && (
            <Text variant="secondary" color="var(--light-60)">
              Started on {startDate}
            </Text>
          )}
          {onLaunch && creditsNeeded && (
            <div className={Styles.launchNow}>
              <CreditUsageButton variant="secondary" fullWidth={false} onPress={onLaunch} credits={creditsNeeded}>
                Launch now
              </CreditUsageButton>
              {startDate && (
                <Text variant="secondary" color="var(--light-60)">
                  Launching on {startDate}
                </Text>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        className={cx(Styles.whyWeRecommendIt, {
          [Styles.withZIndex]: [ContentStrategyType.QuickTips].includes(strategy.id),
        })}
      >
        <Text variant="secondary" color="var(--light-60)">
          Why we recommend it: <span className={Styles.light90}>{whyWeRecommendIt[strategy.id]}</span>
        </Text>
      </div>
      {ImgMap[strategy.id] && (
        <img
          src={ImgMap[strategy.id]}
          alt={strategy.name}
          className={cx(Styles.strategyImg, { [Styles.inModal]: onLaunch || startDate })}
        />
      )}
    </div>
  )
}
